import { Matrix2D, degToRad } from '../utils';
var Camera = /** @class */ (function () {
    function Camera(app) {
        this.app = app;
        this.x = 0;
        this.y = 0;
        this.zoom = 1;
        this.rotation = 0;
        this.followTarget = null;
        this.viewportWidth = 0;
        this.viewportHeight = 0;
    }
    Camera.prototype.setViewport = function (width, height) {
        this.viewportWidth = width;
        this.viewportHeight = height;
    };
    Camera.prototype.pan = function (dx, dy) {
        this.x += dx;
        this.y += dy;
        this.app.requestRender();
        return this;
    };
    Camera.prototype.setPosition = function (x, y) {
        this.x = x;
        this.y = y;
        this.app.requestRender();
        return this;
    };
    Camera.prototype.setZoom = function (zoom) {
        this.zoom = Math.max(0.01, zoom);
        this.app.requestRender();
        return this;
    };
    Camera.prototype.setRotation = function (degrees) {
        this.rotation = degrees;
        this.app.requestRender();
        return this;
    };
    Camera.prototype.follow = function (target) {
        this.followTarget = target;
        return this;
    };
    Camera.prototype.update = function () {
        if (this.followTarget) {
            this.x = this.followTarget.x - this.viewportWidth / (2 * this.zoom);
            this.y = this.followTarget.y - this.viewportHeight / (2 * this.zoom);
        }
    };
    /** Screen to world coordinates */
    Camera.prototype.screenToWorld = function (sx, sy) {
        var cx = this.viewportWidth / 2;
        var cy = this.viewportHeight / 2;
        var m = new Matrix2D();
        m.translate(cx, cy);
        m.scale(this.zoom, this.zoom);
        m.rotate(degToRad(this.rotation));
        m.translate(-this.x - cx / this.zoom, -this.y - cy / this.zoom);
        var inv = m.invert();
        return inv ? inv.transformPoint(sx, sy) : { x: sx, y: sy };
    };
    /** World to screen coordinates */
    Camera.prototype.worldToScreen = function (wx, wy) {
        var cx = this.viewportWidth / 2;
        var cy = this.viewportHeight / 2;
        var m = new Matrix2D();
        m.translate(cx, cy);
        m.scale(this.zoom, this.zoom);
        m.rotate(degToRad(this.rotation));
        m.translate(-this.x - cx / this.zoom, -this.y - cy / this.zoom);
        return m.transformPoint(wx, wy);
    };
    Camera.prototype.getMatrix = function () {
        var cx = this.viewportWidth / 2;
        var cy = this.viewportHeight / 2;
        var m = new Matrix2D();
        m.translate(cx, cy);
        m.scale(this.zoom, this.zoom);
        m.rotate(degToRad(this.rotation));
        m.translate(-this.x - cx / this.zoom, -this.y - cy / this.zoom);
        return m;
    };
    return Camera;
}());
export { Camera };
